var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modal-header\"\u003E\u003Cspan class=\"close-btn header\" ng-click=\"$close()\"\u003E\u003C\u002Fspan\u003E\u003Ch4\u003EHírlevél feliratkozás\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body subscribe\"\u003E\u003Ch3\u003EKöszönjük, hogy megadta az adatait\u003C\u002Fh3\u003E\u003Cp\u003EHamarosan kapni fog a megadott e-mail címre egy levelet, melyben lesz egy megerősítő link, amire kattintva aktiválhatja hírlevélküldő szolgáltatásunkat.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./source/applications/hirlevel/feliratkozas-popup.pug
// module id = 98
// module chunks = 0